// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Mint from 'mint-ui'
import axios from 'axios'
import store from './store'
import './utils/rem'
import '../src/api/httpService'
import { Picker, Popup, SwipeCell, Cell, CellGroup, DatetimePicker, Toast,
  Dialog, Step, Steps, Checkbox, CheckboxGroup, Icon, RadioGroup, Radio, Tabbar, TabbarItem,
  Tab, Tabs, Area, Search, Switch, ImagePreview, Field, NavBar, List
} from 'vant'
import { Swipe, SwipeItem } from 'mint-ui'
import checkFormat from '@/utils/checkFormat.js'

// import Vconsole from 'vconsole'
// const vConsole = new Vconsole()
// Vue.use(vConsole)
import { ActionSheet } from 'vant'
Vue.use(ActionSheet)
Vue.component(Swipe.name, Swipe)
Vue.component(SwipeItem.name, SwipeItem)
import moment from 'moment'

Vue.use(Icon).use(Picker).use(Popup).use(Cell).use(CellGroup).use(SwipeCell).use(DatetimePicker)
  .use(Toast, Dialog, Step, Steps).use(Checkbox, Icon).use(CheckboxGroup).use(RadioGroup).use(Radio).use(Tabbar).use(Area)
  .use(TabbarItem).use(Tab).use(Tabs).use(Search).use(Switch).use(ImagePreview).use(Field).use(NavBar).use(List)
Vue.use(Mint)
import 'mint-ui/lib/style.css'
console.log(process.env.NODE_ENV, 'process.env.API_HOST')
console.log(process.env, 'process.env.API_HOST')
Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.prototype.$store = store
Vue.prototype.$moment = moment
Vue.prototype.$ImagePreview = ImagePreview
moment.locale('zh-cn')// 需要汉化
checkFormat.handleURLkey()
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js